import React, { useState, useCallback, useEffect } from "react";
import {
  Page,
  Card,
  Modal,
  Text,
  Spinner,
  Image,
  Loading,
  Button,
  DataTable,
  ButtonGroup,
  TextContainer,
  Toast,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import AddUser from "./Modals/AddUser";
import { useRef } from "react";
import emptyListImage from "../Assets/Images/emptyList.svg";
import moment from "moment";
import Pagination from "@material-ui/lab/Pagination";
import { useNavigate } from "react-router-dom";
import AddLanguage from "./Modals/AddLanguage";
import { accessSettings } from "../Helpers";

const Languages = () => {
  const navigate = useNavigate();
  const ref = useRef();
  const format = "YYYY-MM-DD HH:mm:ss";
  const modalId = useRef("");
  const perPage = 200;
  const [ts, setTs] = useState("");
  const [isListEmpty, setIsListEmpty] = useState(false);
  const [items, setItems] = useState([]);
  const [availability, setAvailability] = useState("");
  const [queryValue, setQueryValue] = useState("");
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const rows = [
    ["Emerald Silk Gown", "$875.00", 124689, 140, "$122,500.00"],
    ["Mauve Cashmere Scarf", "$230.00", 124533, 83, "$19,090.00"],
    [
      "Navy Merino Wool Blazer with khaki chinos and yellow belt",
      "$445.00",
      124518,
      32,
      "$14,240.00",
    ],
  ];
  const [activeAddUser, setActiveAddUser] = useState(false);
  const handleAddLanguage = () => {
    modalId.current = "add-language";
    setActiveModal(true);
  };
  const [activeModal, setActiveModal] = useState(false);
  const handleChangeModal = () => {
    setActiveModal(!activeModal);
  };
  const handleChangeModalAndRefresh = () => {
    setActiveModal(!activeModal);
    setIsSaving(false);
    setTs(+new Date());
    toggleActive();
  };
  const handleSubmitModal = () => {
    ref.current.handleSave();
  };
  const handleSavingState = () => {
    setIsSaving(true);
  };
  const loadingMarkup = isLoading ? <Loading /> : null;
  const emtyState = isListEmpty ? (
    <div
      style={{
        display: "flex",
        justifyContent: "middle",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div style={{ width: "25%" }}>
        <Image src={emptyListImage}></Image>
      </div>
      <div className="mb-3">
        <Text variant="headingLg" as="h5" color="subdued">
          No results found
        </Text>
      </div>
      <br />
    </div>
  ) : (
    isLoading && (
      <div className="spinnerContainer">
        <div className="vertical-center">
          <Spinner size="large" />
        </div>
      </div>
    )
  );
  const refBoolPage = useRef(true);
  const handleChangePage = (event, value) => {
    refBoolPage.current = true;
    setPage(value);
  };
  useEffect(() => {
    getData();
  }, [ts]);
  const getData = () => {
    axios
      .get(`/settings/languages?filter[is_active]=1`)
      .then((result) => {
        !result.data.data.data.length
          ? setIsListEmpty(true)
          : setIsListEmpty(false);
        // setTotalPages(result.data.data.total);
        setItems(
          result.data.data.data.map((item, index) => [
            // item?.id && item.id,
            <div className="row_click2">{item?.name && item.name}</div>,
            <div className="row_click2">{item?.code && item.code}</div>,
            <div className="me-3">
              <ButtonGroup>
                <Button destructive onClick={() => handleDelete(item.id)}>
                  Delete
                </Button>
              </ButtonGroup>
            </div>,
          ])
        );
        setIsLoading(false);
      })
      .catch(function (error) {
        if (error.response) {
        }
      });
  };
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const [toastContent, setToastContent] = useState(
    "This language has been successfully deleted"
  );
  const toastMarkup = active ? (
    <Toast content={toastContent} onDismiss={toggleActive} />
  ) : null;
  const clickedLanguage = useRef(null);
  const handleEdit = (id) => {
    clickedLanguage.current = id;
    modalId.current = "edit-user";
    setActiveModal(true);
  };
  const [activeDelete, setActiveDelete] = useState(false);

  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    clickedLanguage.current = id;
    setActiveDelete(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    const form_data = new FormData();
    form_data.append("_method", "PATCH");
    form_data.append("is_active", 0);
    axios
      .post(`/settings/languages/${clickedLanguage.current}`, form_data)
      .then((result) => {
        toggleActive();
        setIsSaving(false);
        setActiveDelete(!activeDelete);
        setTs(+new Date());
      })
      .catch((err) => console.log(err));
  };
  const switchModalTitle = (param) => {
    switch (param) {
      case "add-language":
        return "Add Language";

      default:
        return null;
    }
  };

  return (
    accessSettings() && (
      <Page
        title="Languages"
        primaryAction={
          <Button primary onClick={handleAddLanguage}>
            Add Language
          </Button>
        }
      >
        <Card>
          {loadingMarkup}
          <DataTable
            columnContentTypes={["text", "text", "text", "text"]}
            headings={[
              // <Text variant="bodyMd" as="p" fontWeight="medium">
              //   ID
              // </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Language
              </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium">
                Code
              </Text>,
              // <Text variant="bodyMd" as="p" fontWeight="medium">
              //   Created at
              // </Text>,
              <Text variant="bodyMd" as="p" fontWeight="medium"></Text>,
            ]}
            rows={items}
            verticalAlign="middle"
            increasedTableDensity
          />
          {emtyState}
          {totalPages >= 2 && (
            <div
              style={{
                paddingTop: "10px",
                textAlign: "center",
                paddingBottom: "10px",
              }}
            >
              <Pagination
                count={totalPages}
                page={page}
                onChange={handleChangePage}
                size="large"
              />
            </div>
          )}
          <Modal
            open={activeModal}
            onClose={handleChangeModal}
            title={switchModalTitle(modalId.current)}
            primaryAction={{
              content: "Submit",
              onAction: handleSubmitModal,
              loading: isSaving,
            }}
            secondaryActions={[
              {
                content: "Cancel",
                onAction: handleChangeModal,
                loading: isSaving,
              },
            ]}
          >
            <Modal.Section>
              {modalId.current === "add-language" && (
                <AddLanguage
                  ref={ref}
                  handleChangeModalAndRefresh={handleChangeModalAndRefresh}
                  handleSavingState={handleSavingState}
                />
              )}
            </Modal.Section>
          </Modal>

          <Modal
            open={activeDelete}
            onClose={handleChangeModalDelete}
            title="Delete Language"
            primaryAction={{
              content: "Yes",
              onAction: handleYesDelete,
              loading: isSaving,
            }}
            secondaryActions={[
              {
                content: "No",
                loading: isSaving,
                onAction: handleChangeModalDelete,
              },
            ]}
          >
            <Modal.Section>
              <TextContainer>
                <p>Are you sure you want to delete this language?</p>
              </TextContainer>
            </Modal.Section>
          </Modal>
          {toastMarkup}
        </Card>
      </Page>
    )
  );
};

export default Languages;
